import Movimentacao from '@/views/pages/patrimonio/movimentacao/Movimentacao'
import MovimentacaoDetalhe from '@/views/pages/patrimonio/movimentacao/externa/visualizacao/MovimentacaoDetalhe'
import MovimentacaoListagem from '@/views/pages/patrimonio/movimentacao/externa/listagem/MovimentacaoListagem'
import MovimentacaoListagemPendente from '@/views/pages/patrimonio/movimentacao/externa/listagem/MovimentacaoListagemPendente'
import MovimentacaoBaixaListagem
    from '@/views/pages/patrimonio/movimentacao/baixa/listagem/MovimentacaoBaixaListagem.vue'
import MovimentacaoExterna from '@/views/pages/patrimonio/movimentacao/externa/MovimentacaoExterna.vue'

export default [
    {
        path: '/movimentacoes',
        name: 'TodasMovimentacoes',
        component: Movimentacao,
        meta: {
            menu: {
                title: 'Movimentações',
                icon: 'fas fa-exchange-alt',
            },
            requiresAuth: true,
            authorities: ['Patrimonio.Normal', 'Patrimonio.Consulta']
        },
        children: [
            {
                path: '/movimentacoes/externas',
                name: 'TodasMovimentacoes',
                component: MovimentacaoExterna,
                meta: {
                    menu: {
                        title: 'Externas'
                    },
                    page: {
                        title: 'Movimentações Externas',
                        subtitle: 'Lista geral das movimentações dos patrimônios'
                    },
                    requiresAuth: true,
                    authorities: ['Patrimonio.Normal', 'Patrimonio.Consulta']
                },
                children: [
                    {
                        path: '/movimentacoes/externas/todas',
                        name: 'MovimentacaoListagem',
                        component: MovimentacaoListagem,
                        meta: {
                            requiresAuth: true,
                            authorities: ['Patrimonio.Normal', 'Patrimonio.Consulta']
                        }
                    },
                    {
                        path: '/movimentacoes/externas/receber',
                        name: 'MovimentacaoListagemPendente',
                        component: MovimentacaoListagemPendente,
                        meta: {
                            requiresAuth: true,
                            authorities: ['Patrimonio.Normal', 'Patrimonio.Consulta']
                        }
                    }
                ]
            },
            {
                path: '/movimentacoes/baixas/todas',
                name: 'MovimentacaoBaixaListagem',
                component: MovimentacaoBaixaListagem,
                meta: {
                    menu: {
                        title: 'Baixas'
                    },
                    page: {
                        title: 'Movimentações Baixas',
                        subtitle: 'Lista geral das baixas patrimoniais'
                    },
                    requiresAuth: true,
                    authorities: ['Patrimonio.Normal', 'Patrimonio.Consulta']
                }
            }
        ]
    },
    {
        path: '/movimentacao/:id/visualizar',
        name: 'MovimentacaoDetalhe',
        component: MovimentacaoDetalhe,
        meta: {
            page: {
                title: 'Visualizar Movimentação'
            },
            requiresAuth: true,
            authorities: ['Patrimonio.Normal', 'Patrimonio.Consulta']
        },
    }
]
